interface IBuildertrendTakeOffLogoProps {
    height?: number;
    width?: number;
}

export const BuildertrendTakeOffLogo: React.FunctionComponent<IBuildertrendTakeOffLogoProps> = ({
    height,
    width,
}) => (
    <img
        alt="Buildertrend Takeoff Logo"
        height={height ? `${height}px` : ""}
        width={width ? `${width}px` : ""}
        src="/images/Marketplace/BTTakeoffPoweredBySquareTakeoff.svg"
    />
);
